import { EntityIconMd } from '@components/core-ui/EntityIcon/variations/EntityIconMd';
import { Dispatch, SetStateAction } from 'react';
import { TSelectableMiniTeamCardItem } from './types/TSelectableMiniTeamCardItem';

type TProps = {
  team: TSelectableMiniTeamCardItem;
  selectedTeams: string[];
  setSelectedTeams: Dispatch<SetStateAction<string[]>>;
};

export const SelectableMiniTeamCards = ({ team, selectedTeams, setSelectedTeams }: TProps) => {
  const selected = selectedTeams.includes(team.id);

  const handleClick = () => {
    if (selected) {
      setSelectedTeams(selectedTeams.filter((id) => id !== team.id));
    } else {
      setSelectedTeams([...selectedTeams, team.id]);
    }
  };

  return (
    <li
      key={team.name}
      className={`col-span-1 flex rounded-md shadow-sm w-5/12 m-1 hover:bg-surface-muted cursor-pointer ${
        selected ? 'bg-[var(--color-avatar-bg)]' : ''
      }`}
      onClick={handleClick}
      title={team.name}
    >
      <EntityIconMd name={team.name || team.slug || ''} backgroundColor={team.colour} color="var(--color-surface)" />
      <div className="flex flex-1 items-center justify-between truncate rounded-r-md border-t border-r border-b">
        <div className="flex-1 truncate px-4 py-2 text-sm">
          <div className="font-medium text-[var(--color-title)] text-ellipsis overflow-hidden">{team.name}</div>
        </div>
      </div>
    </li>
  );
};
